import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { cursorAtom } from "../diagramming";
import { isViewOnlyModeAtom } from "../permissions";
import {
  isDraftModeIncludingTemplatesAtom,
  isNodeHoveredAtomFamily,
  isOnlyNodeSelectedAtomFamily,
} from "../nodes";
import {
  isConnectingEdgeInProgressAtom,
  isReconnectingEdgeInProgressAtom,
} from "../edges";

export const areHandlesVisibleAtomFamily = atomFamily(
  (nodeId: string | undefined) => {
    if (!nodeId) {
      return atom(false);
    }

    const baseAtom = atom((get) => {
      const cursorMode = get(cursorAtom);
      const isInConnectMode = cursorMode === "connect";
      const isViewOnlyMode = get(isViewOnlyModeAtom);
      const isDraftModeIncludingTemplates = get(
        isDraftModeIncludingTemplatesAtom,
      );

      const isNodeHovered = get(isNodeHoveredAtomFamily(nodeId));
      const isNodeSelected = get(isOnlyNodeSelectedAtomFamily(nodeId));
      const isEdgeConnectionInProgress = get(isConnectingEdgeInProgressAtom);
      const isEdgeReconnectionInProgress = get(
        isReconnectingEdgeInProgressAtom,
      );

      return (
        !isViewOnlyMode &&
        !isDraftModeIncludingTemplates &&
        (isNodeHovered ||
          isNodeSelected ||
          isInConnectMode ||
          isEdgeConnectionInProgress ||
          isEdgeReconnectionInProgress)
      );
    });

    baseAtom.debugLabel = `areHandlesVisibleAtomFamily(${nodeId})`;
    return baseAtom;
  },
);
